import { ProjectErrorComponent } from "@/components/error";
import { toError } from "@/lib/to-error";
import { ProjectWorkspace } from "@/components/project/project-workspace";
import { orpc } from "@/lib/orpc";
import { useSuspenseQuery } from "@tanstack/react-query";
import { PendingProjectComponent } from "@/components/pending";
import { projects } from "@papier/projects-schema";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { z } from "zod";
import { environmentSearch } from "@/components/project/environment-search";

export const Route = createFileRoute("/_app/projects/$projectSlug/_layout")({
  component: ProjectLayout,
  validateSearch: environmentSearch,
  params: {
    parse: (params) => {
      return z.object({ projectSlug: projects.shape.slug }).parse(params);
    },
  },
  pendingComponent: () => <PendingProjectComponent />,
  errorComponent: ({ error }) => <ProjectErrorComponent error={toError(error)} />,
  loader: async ({ context: { queryClient, orpc }, params }) => {
    const project = await queryClient.ensureQueryData(
      orpc.projects.getBySlug.queryOptions({ input: params }),
    );
    queryClient.prefetchQuery(
      orpc.templates.getAllWithUserDrafts.queryOptions({ input: { projectId: project.id } }),
    );
    return { name: project.name };
  },
  head: ({ loaderData }) => ({
    meta: [{ title: `Papier - ${loaderData?.name || "Project"}` }],
  }),
});

function ProjectLayout() {
  const params = Route.useParams();
  const { env } = Route.useSearch();
  const { data: project } = useSuspenseQuery(
    orpc.projects.getBySlug.queryOptions({ input: params }),
  );
  return (
    <ProjectWorkspace project={project} environmentSlug={env}>
      <Outlet />
    </ProjectWorkspace>
  );
}
